import React, { useEffect, useState, useRef } from 'react'
import { Input, Button, Text, Heading, Select } from '../ui'
import { useRoadmapStore } from '../../stores/projetos/roadmapStore'

const statuses = [
  { key: 'ideia', label: 'Ideia' },
  { key: 'planejado', label: 'Planejado' },
  { key: 'em_andamento', label: 'Em andamento' },
  { key: 'concluido', label: 'Concluído' },
  { key: 'bloqueado', label: 'Bloqueado' }
]

export const RoadmapFilters: React.FC = () => {
  const { filters, groups, labels, setFilters, reload } = useRoadmapStore()
  const [searchValue, setSearchValue] = useState(filters.q)
  const reloadTimeoutRef = useRef<NodeJS.Timeout | null>(null)

  // Função para aplicar filtros com debounce
  const applyFilters = () => {
    if (reloadTimeoutRef.current) {
      clearTimeout(reloadTimeoutRef.current)
    }
    reloadTimeoutRef.current = setTimeout(() => {
      reload()
    }, 300)
  }

  // Debounce para o campo de busca
  useEffect(() => {
    const timer = setTimeout(() => {
      if (searchValue !== filters.q) {
        setFilters({ q: searchValue })
        applyFilters()
      }
    }, 500)

    return () => clearTimeout(timer)
  }, [searchValue])

  // Aplicar filtros quando mudarem (exceto busca que já tem debounce próprio)
  useEffect(() => {
    applyFilters()
  }, [filters.from, filters.to, filters.group_id, filters.status, filters.label_id, filters.me])

  // Limpar timeout ao desmontar
  useEffect(() => {
    return () => {
      if (reloadTimeoutRef.current) {
        clearTimeout(reloadTimeoutRef.current)
      }
    }
  }, [])

  const handleFilterChange = (updates: Partial<typeof filters>) => {
    setFilters(updates)
  }

  const clear = () => {
    setSearchValue('')
    setFilters({ q: '', from: null, to: null, group_id: null, status: null, label_id: null, me: false })
    setTimeout(() => reload(), 0)
  }

  return (
    <div className="bg-white dark:bg-gray-800 shadow rounded-lg p-4">
      <div className="mb-4">
        <Heading as="h3" size="2xl" className="text-gray-900 dark:text-white">
          Filtros
        </Heading>
      </div>
      <div>
        <div className="grid grid-cols-1 md:grid-cols-12 gap-4 items-end">
          <div className="md:col-span-3">
            <Text size="sm" className="text-gray-700 dark:text-gray-300 mb-2 block">Buscar</Text>
            <Input
              type="text"
              placeholder="Buscar por título ou descrição..."
              value={searchValue}
              onChange={(e: any) => setSearchValue(e.target.value)}
            />
          </div>
          <div className="md:col-span-2">
            <Text size="sm" className="text-gray-700 dark:text-gray-300 mb-2 block">Data Inicial</Text>
            <Input
              type="date"
              value={filters.from || ''}
              onChange={(e) => handleFilterChange({ from: e.target.value || null })}
            />
          </div>
          <div className="md:col-span-2">
            <Text size="sm" className="text-gray-700 dark:text-gray-300 mb-2 block">Data Final</Text>
            <Input
              type="date"
              value={filters.to || ''}
              onChange={(e) => handleFilterChange({ to: e.target.value || null })}
            />
          </div>
          <div className="md:col-span-2">
            <Text size="sm" className="text-gray-700 dark:text-gray-300 mb-2 block">Grupo</Text>
            <Select
              value={filters.group_id || ''}
              onChange={(e) => handleFilterChange({ group_id: e.target.value || null })}
            >
              <option value="">Todos os grupos</option>
              {groups.map((g) => (
                <option key={g.id} value={g.id}>{g.name}</option>
              ))}
            </Select>
          </div>
          <div className="md:col-span-2">
            <Text size="sm" className="text-gray-700 dark:text-gray-300 mb-2 block">Status</Text>
            <Select
              value={filters.status || ''}
              onChange={(e) => handleFilterChange({ status: e.target.value || null })}
            >
              <option value="">Todos os status</option>
              {statuses.map(s => <option key={s.key} value={s.key}>{s.label}</option>)}
            </Select>
          </div>
          <div className="md:col-span-1 flex items-end">
            <label className="inline-flex items-center gap-2 text-sm text-gray-700 dark:text-gray-300 mb-2">
              <input
                type="checkbox"
                checked={filters.me}
                onChange={(e) => handleFilterChange({ me: e.target.checked })}
                className="rounded border-gray-300 dark:border-gray-600 text-blue-600 focus:ring-blue-500 dark:bg-gray-700 dark:checked:bg-blue-600"
              />
              Apenas meus
            </label>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-12 gap-4 items-end mt-4">
          <div className="md:col-span-2">
            <Text size="sm" className="text-gray-700 dark:text-gray-300 mb-2 block">Tag</Text>
            <Select
              value={filters.label_id || ''}
              onChange={(e) => handleFilterChange({ label_id: e.target.value || null })}
            >
              <option value="">Todas as tags</option>
              {labels.map(l => (
                <option key={l.id} value={l.id}>{l.name}</option>
              ))}
            </Select>
          </div>
          <div className="md:col-span-10 flex justify-end">
            <Button type="button" variant="outline" size="sm" onClick={clear}>
              Limpar Filtros
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default RoadmapFilters


